export enum SearchTab {
  City,
  Route
}
